// @flow
import * as React from 'react'
import moment from 'moment'
import { FormattedMessage } from 'mz-intl'
import { Button, ButtonToolbar } from '../../../../core/Button'
import { Footer } from '../../../../core/LightboxBaseField'
import HorizontalCalendar from '../../HorizontalCalendar'
import { Container } from './elements'
import commonMessages from '../../../../messages.intl'

// Types
import type { Props } from '..'

type State = {
  dateTime: moment,
}

/**
 * Separate lightbox component to keep intermediate selected date in
 * the component state. The intermediate value initiated only when the lightbox
 * opened.
 * @extends React
 */
class Lightbox extends React.Component<*, State> {
  state = {
    dateTime: moment(),
  }

  componentDidMount() {
    this.initValue(this.props)
  }

  initValue(props: Props) {
    const {
      input: { value },
    } = props

    const defaultDate = this.props.minDate ?? moment()
    const dateValue = value ? moment(value) : defaultDate

    this.setState({ dateTime: dateValue })
  }

  handleChangeDate = (value: Object) => {
    const prevValue = this.state.dateTime

    // keep time and change date
    const newDateTime = prevValue
      .clone()
      .year(value.year())
      .month(value.month())
      .date(value.date())

    this.setState({ dateTime: newDateTime })
  }

  render() {
    return (
      <div>
        <Container>
          <HorizontalCalendar
            value={this.state.dateTime}
            onChange={this.handleChangeDate}
            minDate={this.props.minDate}
            maxDate={this.props.maxDate}
          />
        </Container>
        <Footer>
          <ButtonToolbar>
            <Button fullWidth appearance="flat" onClick={this.props.onCancel}>
              <FormattedMessage message={commonMessages.CANCEL} />
            </Button>
            <Button
              innerRef={this.props.setFocusableRef}
              onClick={() => this.props.onSelect(this.state.dateTime)}
              fullWidth
            >
              <FormattedMessage message={commonMessages.SET} />
            </Button>
          </ButtonToolbar>
        </Footer>
      </div>
    )
  }
}

export default Lightbox
